import { render, staticRenderFns } from "./SchedaArruolamento.vue?vue&type=template&id=e37a4af8&"
import script from "./SchedaArruolamento.vue?vue&type=script&lang=js&"
export * from "./SchedaArruolamento.vue?vue&type=script&lang=js&"
import style0 from "./SchedaArruolamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports